
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/imageToBackground/components/imageToBackground.scss.css.virtualfile';
        module.exports = {"wrapper":"_wrapper_soo1m_7","backgroundIcon":"_backgroundIcon_soo1m_21"};